const SCROLLABLE_OVERFLOW = new Set(["auto", "scroll", "overlay"]);

export function isScrollContainer(el: HTMLElement): boolean {
  const { overflowY } = getComputedStyle(el);
  return SCROLLABLE_OVERFLOW.has(overflowY);
}

/**
 * Resolves the scroll container for BV Express content.
 * Mobile and web hosts mount the viewer inside `.content-frame`.
 */
export function getScrollRoot(container: HTMLElement | null): HTMLElement | null {
  if (!container) {
    return null;
  }

  const contentFrame = container.closest(".content-frame") as HTMLElement | null;

  if (contentFrame && isScrollContainer(contentFrame)) {
    return contentFrame;
  }

  return container;
}

/** Resets scroll on `.content-frame` (or the viewer container fallback). */
export function resetScrollRoot(container: HTMLElement | null): void {
  const scrollRoot = getScrollRoot(container);
  if (!scrollRoot) {
    return;
  }

  scrollRoot.scrollTop = 0;
  scrollRoot.scrollLeft = 0;
}
